import { throwUnsupportedRuntimeError } from "../error.ts";
export * from "../cli/common.ts";
export async function run(cmd, args) {
    void cmd, args;
    throwUnsupportedRuntimeError();
}
export async function powershell(script) {
    void script;
    throwUnsupportedRuntimeError();
}
export async function sudo(cmd, args, options = {}) {
    void cmd, args, options;
    throwUnsupportedRuntimeError();
}
export async function which(cmd) {
    void cmd;
    throwUnsupportedRuntimeError();
}
export async function edit(filename) {
    void filename;
    throwUnsupportedRuntimeError();
}
//# sourceMappingURL=cli.js.map